async function getLab(laboratorio) {
  const requestOptions = {
    method: "POST",
    body: JSON.stringify({
      cnpj: laboratorio,
    }),
  };

  return fetch(process.env.REACT_APP_LABS_API + "OEC/laboratorio/get_lab_by_cnpj.php", requestOptions)
    .then(response => {
      return response.json();
    })
    .then(json => {
      if (json.status == 200) {
        return json;
      } else {
        return false;
      }
    });
}

export { getLab };
